export const DEFAULT_UI_LIBRARY = 'antd';
